import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/admins/sidebar.css";
import { useNavigate } from "react-router-dom";
import logo from "../../images/user.png";

function AdminSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/exclserv-admin");
    window.location.reload();
  };

  return (
    <div
      className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul className="sidebar-menu">
        <div className="side-logo-container">
          <img
            src={logo}
            className={`side-logo ${isCollapsed ? "collapsed" : ""}`}
            alt="logo"
          />
        </div>
        <NavLink to="/admin/dashboard">
          <i className="bx bxs-home-smile"></i>
          <li>Dashboard</li>
        </NavLink>
        <br />
        <NavLink to="/admin/inventory">
          <i className="bx bxs-customize"></i>
          <li>Inventory</li>
        </NavLink>
        <br />
        <NavLink to="/admin/companies">
          <i className="bx bxs-buildings"></i>
          <li>Companies</li>
        </NavLink>
        <br />
        <NavLink to="/admin/users">
          <i className="bx bxs-user"></i>
          <li>View Users</li>
        </NavLink>
        <br />
        <NavLink to="/admin/add-technicians">
          <i className="bx bxs-wrench"></i>
          <li> Engineer</li>
        </NavLink>
        <br />
        <NavLink to="/admin/reports">
          <i className="bx bxs-bar-chart-alt-2"></i>
          <li>View Report</li>
        </NavLink>
        <br />
        <NavLink to="/admin/tickets">
          <i className="bx bxs-purchase-tag-alt"></i>
          <li>View Tickets</li>
        </NavLink>
        <br />
        <NavLink to="/admin/logout" onClick={handleLogout}>
          <i className="bx bx-log-out-circle"></i>
          <li>Logout</li>
        </NavLink>
      </ul>
    </div>
  );
}

export default AdminSidebar;
